export default {
  logoutReason: Object.freeze({
    LOGOUT: 'logout', INACTIVE_SESSION: 'inactive-session', INVALID_TOKEN: 'invalid-token',
    END_OF_SESSION: 'end-of-session'
  }),
}
